import React, { useEffect, useState } from "react";
import { SafeArea } from "capacitor-plugin-safe-area";

function SafeAreaView({ children }: { children: React.ReactNode }) {
  const [safeTop, setSafeTop] = useState(0);

  useEffect(() => {
    (async function () {
      if (import.meta.env.VITE_PLATFORM === "mobile") {
        setTimeout(async () => {
          const { StatusBar, Style } = await import("@capacitor/status-bar");
          await StatusBar.setOverlaysWebView({ overlay: false });
          await StatusBar.setStyle({ style: Style.Dark });
          await StatusBar.setBackgroundColor({ color: "#3a405a" });
        }, 100);

        const safeAreaData = await SafeArea.getSafeAreaInsets();
        const { insets } = safeAreaData;

        setSafeTop(insets.top);
      }
    })();
  }, []);

  return (
    <>
      {import.meta.env.VITE_PLATFORM === "mobile" &&
      import.meta.env.VITE_MOBILE === "android" ? (
        <div
          style={{
            paddingTop: safeTop > 0 ? `${safeTop}px` : "0px",
          }}
        >
          {children}
        </div>
      ) : (
        <div>{children}</div>
      )}
    </>
  );
}

export default SafeAreaView;
